import { z } from 'zod/v4';

import { throwErrorUnlessProduction } from '../resources/http/throwErrorUnlessProduction';

export const assertZodSchemaUnlessProduction = (data: unknown, schema: z.ZodTypeAny): void => {
    try {
        schema.parse(data);
    } catch (error) {
        throwErrorUnlessProduction(error);
    }
};
